import NavigationHeader from "../components/Layout/NavigationHeader";

const MissingPage = () => {
  return (
    <div className={"page_content"}>
      <NavigationHeader />
      <h2>
        404
      </h2>
      <span>
        The page or document you are trying to access cannot be found or is missing.
      </span>
    </div>);
};

export default MissingPage;
